<template>
    <div>
        <group-card title="Brokers" icon="real_estate_agent" padded>
            <template slot="actions">
                <md-button
                    class="md-icon-button md-primary md-simple new-app-button"
                    @click="onDialogAction(true)"
                >
                    <md-icon id="new-app-icon">note_add</md-icon>
                    Import Broker
                    <md-tooltip md-direction="top">Import Broker CSV</md-tooltip>
                </md-button>
                <md-button 
                    class="md-icon-button md-primary md-simple"
                    @click="$router.push('/administration/user_management/broker/new')"
                >
                    <md-icon>add</md-icon>
                    <md-tooltip md-direction="top">Add New Broker</md-tooltip>
                </md-button>
                <loading-icon-button
                    @click="refreshBrokers"
                    tooltip="Refresh"
                    :loading="progress_indicator.broker_list"
                >
                    cached
                </loading-icon-button>
            </template>
            <!-- Import CSV Editor -->
            <md-dialog :md-active.sync="upload_csv_dialog.show_dialog">
                <group-card :title="upload_csv_dialog.title" icon="attach_file">
                    <ValidationObserver ref="form_upload_template">
                        <form enctype="multipart/form-data">
                            <div class="md-layout">
                                <p>{{ upload_csv_dialog.content }}</p>
                            </div>
                            <div class="md-layout">
                                <!-- CSV Upload -->
                                <md-field>
                                <label>Import CSV file only</label>
                                <md-file
                                    v-model="upload_csv_dialog.file_name"
                                    accept="text/csv"
                                    name="file"
                                    @change="onFileChange"
                                    required
                                />
                                </md-field>
                            </div>
                            <div>
                                <md-button class="md-primary md-simple md-danger" @click="onDialogAction(false)">Cancel</md-button>
                                <md-button class="md-primary" @click="importHubSpotCSV">Import</md-button>
                                <md-progress-spinner
                                    v-if="upload_csv_dialog.loading"
                                    :md-diameter="30"
                                    :md-stroke="3"
                                    md-mode="indeterminate"
                                />
                            </div>
                        </form>
                    </ValidationObserver>
                </group-card>
            </md-dialog>
            <div  data-app>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
                <v-data-table
                    :headers="brokerHeaders"
                    :items="brokers"
                    :search="search"
                    item-key="id"
                    :items-per-page="10"
                    class="elevation-0 broker_table"
                    :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'first_page',
                    lastIcon: 'last_page',
                    prevIcon: 'skip_previous',
                    nextIcon: 'skip_next'}"
                    :loading="progress_indicator.broker_list"
                    loading-text="Loading... Please wait"
                >
                    <template v-slot:item.name="{ item }">
                        {{item.name | name}}
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <span>
                            <v-icon
                                small
                                class="mr-2"
                                @click="viewBroker(item)"
                            >
                                open_in_new
                            </v-icon>
                            <md-tooltip md-direction="top">Open</md-tooltip>
                        </span>
                    </template>
                </v-data-table>
            </div>
        </group-card>
    </div>
</template>
<script>
import filters from "@/components/utils/filters";
import {GroupCard} from "@/components";
import {mapGetters} from "vuex";
import LoadingIconButton from '@/components/LoadingIconButton';
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog";

export default {
    components:{
        GroupCard,
        LoadingIconButton,
        ConfirmDialog
    },
    data(){
        return {
            brokers: [],
            search: '',
            progress_indicator: {
                broker_list: false,
            },
            brokerHeaders: [
                {
                    text: "Broker Id",
                    align: 'center',
                    sortable: true,
                    value: 'id',
                    width: '200px',
                    align: 'center'
                },
                {text: 'Full Name', value: 'name', align: 'center'},
                {text: 'Email', value: 'email', align: 'center'},
                {text: 'Employment Type', value: 'employment_type', align: 'center'},
                {text: 'Pod', value: 'broker_pod', align: 'center'},
                {text: 'Actions', value: 'actions', sortable: false, align: 'center'},
            ],
            upload_csv_dialog: {
                show_dialog: false,
                title: 'Import CSV',
                file_name: '',
                file: null,
                loading: false,
                content: 'Upload CSV from HubDB broker table.',
            }
        }
    },
    methods:{
        async getBrokers(force = false) {
            this.progress_indicator.broker_list = true
            var response = await this.$store.dispatch('fetch_administration_brokers', force);
            if (response) {
                this.brokers = this.savedBrokers();
            }
            this.progress_indicator.broker_list = false
        },
        async refreshBrokers() {
            await this.getBrokers(true);
        },
        viewBroker(item) {
            this.$router.push(`/administration/user_management/broker/${item.id}/view`)
        },
        onDialogAction(show = false) {
            this.upload_csv_dialog.file_name = '';
            this.upload_csv_dialog.file = null;
            this.upload_csv_dialog.show_dialog = show;
        },
        onFileChange(event) {
            this.upload_csv_dialog.file = event.target.files[0];
        },
        async importHubSpotCSV() {
            this.upload_csv_dialog.loading = true;
            const response = await this.$store.dispatch('import_hubspot_csv', {
                file: this.upload_csv_dialog.file,
                type: 'hubspot_broker',
            })
            if (response.status == 200) {
                await this.showConfirmDialog("Success", "Upload CSV Successfully.");
                this.upload_csv_dialog.show_dialog = false;
            } else {
                const message = response.message.error.map( e => {
                    return `<p>row ${e['index']}: ${e['message']}</p>`;
                }).join('');
                this.showConfirmDialog("Error", message);
            }
        },
        async showConfirmDialog(title, message) {
            this.upload_csv_dialog.loading = false;
            return await this.$modal.show(ConfirmDialog, {
                title: title,
                message: message,
                confirmText: "Close",
            });
        },
    },
    created() {
      // TODO: Current need to force fetch since workbasket broker dropdown store in same array. Fix this after release.
      this.getBrokers(true)
    },
    computed: {
        ...mapGetters({
            savedBrokers: 'administrationBrokers',
        }),
    },
    filters: {
        ...filters,
    }
}
</script>
<style lang="scss" scoped>
.broker_table {
    table {
        td {
            text-align: center;
        }
    }

    .v-data-footer__select {
        display: none;
    }
}
</style>

